// Substitute id/name placeholders in a suggested-action prompt template.
// `names` is parallel to `ids` (names[i] is the display name for ids[i]).
//
// Tokens:
//   {ids} / {count} / {first_id} / {first_appid} / {app_ids}
//   {first_name}        — first recipient's name ("the candidate" if unknown)
//   {recipients_phrase} — "Joseph Martinez" for one, "each of the N selected
//                         candidates" for many — so an email chip reads right
//                         whether one or several candidates are selected
//   {it_or_them}        — "it" for one, "each" for many
export const fillIdPlaceholders = (
  template: string,
  ids: string[],
  appIds?: string[],
  names?: string[]
): string => {
  const count = ids.length;
  const firstName = names?.[0]?.trim() || 'the candidate';
  const recipientsPhrase =
    count <= 1 ? firstName : `each of the ${count} selected candidates`;
  const itOrThem = count <= 1 ? 'it' : 'each';
  return template
    .replaceAll('{ids}', ids.join(', '))
    .replaceAll('{count}', String(count))
    .replaceAll('{first_id}', ids[0] ?? '')
    .replaceAll('{first_appid}', appIds?.[0] ?? '')
    .replaceAll('{app_ids}', (appIds ?? []).join(', '))
    .replaceAll('{recipients_phrase}', recipientsPhrase)
    .replaceAll('{it_or_them}', itOrThem)
    .replaceAll('{first_name}', firstName);
};
